<a
  [routerLink]="
    helpukraine
      ? [
          '/projects/' +
            project.projectStatus.name.replace('_', '-') +
            '/' +
            'helpukraine' +
            '/' +
            project.id
        ]
      : ['/projects/' + project.projectStatus.name.replace('_', '-') + '/' + project.id]
  "
  class="project-box"
  [ngClass]="{ 'project-box--promoted': project.promoted }"
  *ngIf="project"
>
  <div class="project-box__image">
    <img
      [src]="layout === 'list' ? project.fullMainImg : project.mainImg"
      alt="{{ project.name }}"
    />
    <div class="project-box__draft-actions">
      <button class="btn btn--primary btn--sm" (click)="goToEdit($event)">
        {{ 'PROJECT.BOX.edit_project' | translate }}
      </button>
      <button (click)="openDeleteModalDraft($event)" class="btn btn--fill--white btn--sm">
        {{ 'PROJECT.BOX.delete_draft' | translate }}
      </button>
      <div class="project-box__draft-info">
        {{ 'PROJECT.BOX.created' | translate }}: {{ project.dateFromNow }}
      </div>
    </div>
  </div>
  <div class="project-box__labels">
    <app-ph-label [color]="badge.color" *ngIf="badge">{{ badge.text }}</app-ph-label>
    <app-ph-label [color]="'light-red'" *ngIf="project.promoted">
      <img src="assets/img/icons/leaf.svg" [alt]="'PROJECT.status.featured' | translate" />
      <span>{{ 'PROJECT.status.featured' | translate }}</span>
    </app-ph-label>
    <app-ph-label [color]="'light-yellow'" *ngIf="project.rate_count >= 5">
      <img src="assets/img/icons/star.svg" [alt]="project.vote_counter | vote" />
      <span class="project__bar-rank--value">{{
        project.rate_count >= 5 ? (project.vote_counter | vote) : '-'
      }}</span>
    </app-ph-label>
  </div>
  <div class="project-box__content">
    <div class="project-box__title">
      <span>{{ project.name }}</span>
      <div class="projects-table__hint" *ngIf="project.name.length > 25">
        {{ project.name }}
      </div>
    </div>
    <div class="project-box__info">
      <div
        *ngIf="!projectOnList([590]) && !helpukraine && !containHelpUkraineTag()"
        class="project-box__bags"
      >
        {{ project.bagsCount }}
        <span *ngIf="project.bagsCount === 1">{{ 'CART.bag_picked' | translate }}</span>
        <span *ngIf="project.bagsCount > 1 && project.bagsCount < 5">{{
          'CART.bags_picked' | translate
        }}</span>
        <span *ngIf="project.bagsCount > 4 || project.bagsCount === 0">{{
          'CART.more_bags_picked' | translate
        }}</span>
      </div>
      <div class="project-box__donations" *ngIf="project.donated_money > 0">
        {{ 'PROJECT.BOX.donates' | translate }}
        {{ project.donated_money | currencyAmount : project.currency }}
        <span class="project-box__donations--goal" *ngIf="project?.goal_amount">
          {{ 'PROJECT.BOX.of' | translate }}
          {{ project?.goal_amount | currencyAmount : project.currency }}
        </span>
      </div>
    </div>
    <div class="project-box__bar">
      <ng-container *ngIf="project?.goal_amount; else separator">
        <div class="project__cart-support--bar">
          <app-ph-progress-bar
            [current]="project?.donated_money"
            [total]="project?.goal_amount"
            [isClosed]="project?.status === 1"
          ></app-ph-progress-bar>
        </div>
      </ng-container>
      <ng-template #separator>
        <div class="project-box__separator"></div>
      </ng-template>
    </div>
    <div class="project-box__location">
      {{ 'COUNTRIES.' + project.country | translate }},
      {{ 'CONTINENTS.' + project.continent | translate }}
      <span class="project-box__date" *ngIf="project.status === 1">
        <div class="clock clock--daysleft"></div>
        {{ 'PROJECT.project_closed' | translate }}
      </span>
      <span
        class="project-box__date"
        *ngIf="projectEndDaysLeft > 0 && project.status !== 1"
        [ngClass]="{ 'project-box__date-danger-label': projectEndDaysLeft <= 5 }"
      >
        <div
          class="clock clock--daysleft"
          [ngClass]="{ 'clock--daysleft--danger-icon': projectEndDaysLeft <= 5 }"
        ></div>
        <span>{{ projectEndDaysLeft }} {{ 'PROJECT.days_left' | translate }}</span>
      </span>
    </div>
    <div class="project-box__categories">
      <app-categories [categories]="project.categories" elementType="project"></app-categories>
    </div>
  </div>
</a>

<p-dialog
  [(visible)]="displaydeleteModalDraft"
  [dismissableMask]="true"
  [modal]="true"
  (onHide)="closeDeleteModalDraft()"
  [style]="{ width: '600px' }"
>
  <div style="padding: 40px 80px">
    <div class="modal__wrapper">
      <div class="modal__title">
        {{ 'PROJECT.draft_delete_are_you_sure' | translate }}
      </div>
      <div class="modal__description">
        {{ 'PROJECT.draft_delete_are_you_sure_info' | translate }}
      </div>
      <div class="modal__actions">
        <button class="btn btn--outline btn--md mw-160" (click)="closeDeleteModalDraft()">
          {{ 'GLOBAL.cancel' | translate }}
        </button>
        <button class="btn btn--danger btn--md mw-160" (click)="projectDeleteDraft()">
          {{ 'PROJECT.draft_delete' | translate }}
        </button>
      </div>
    </div>
  </div>
</p-dialog>
